'use client'

import { BreadCrumbNavBar } from '@/components/navigation/breadcrumb-navbar'
import { ResolvedImage } from '@/components/utility/image'
import { PaginationGrid } from '@/components/utility/pagination/pagination-grid'
import collections from '@/data/collections.json'
import Link from 'next/link'
import { type ReactNode } from 'react'

const CollectionsTitle = ({ children }: { children: ReactNode }) => (
  <h1 className='ml-1 flex-1 text-[32px] font-bold leading-10 text-primary-dark'>
    {children}
  </h1>
)

const CollectionsSeoContainer = ({ children }: { children: ReactNode }) => (
  <div className='mt-8 flex-1 text-left text-sm font-medium leading-5 text-primary-dark'>
    {children}
  </div>
)

const HeaderContainer = ({ children }: { children: ReactNode }) => (
  <div className='mt-[5%]'>{children}</div>
)

const collectionDataList = collections.map(
  ({ imageUrl, lasooUrl, collectionName }, index) => {
    return (
      <div
        key={index}
        data-testid='collection-page-card'
        className='relative aspect-[1145/767] h-auto w-full sm:max-w-[393px]'
      >
        <Link href={lasooUrl}>
          <ResolvedImage
            fill
            sizes='(maxWidth: 616px) 194px, (maxWidth: 932px) 304px, 392px'
            src={imageUrl}
            alt={collectionName}
            shouldUseRoot
            className='z-[1]'
          />
          <div className='absolute inset-x-3 inset-y-[15px] z-0 animate-pulse rounded-2xl bg-gray-200' />
        </Link>
      </div>
    )
  },
)

export default function CollectionsPage() {
  return (
    <div>
      <BreadCrumbNavBar breadcrumbs={[{ label: 'Collections' }]} />
      <HeaderContainer>
        <CollectionsTitle data-testid='brands-title'>
          Afterpay Day Sale
        </CollectionsTitle>
        <CollectionsSeoContainer data-testid='brands-seo-container'>
          {''}
        </CollectionsSeoContainer>
      </HeaderContainer>
      <PaginationGrid
        elements={collectionDataList}
        title=''
        isSkeleton={false}
        showBottomPagination
        cursor={1}
        totalPages={1}
        currentPage={1}
        gridClassName={'sm:grid-cols-3 grid-cols-1'}
        itemPerPage={3}
      />
    </div>
  )
}
